export default __webpack_public_path__ + "static/media/healthcare.ba883832.png";